<template>
  <template v-if="user">
    <AppPaymentWallWrapper />
    <AppLoadingBar />
    <template v-if="showOnboardingWizard && isOnboardingRoute">
      <router-view />
    </template>
    <template v-else>
      <AppTopMenu />
      <main :class="wrapperClasses">
        <AppMaxVolumeAlert />
        <AppTitleBar v-if="!isSettingsRoute" />
        <router-view />
      </main>

      <AppStatuspageWidget v-if="settings" />
      <NotificationPanelWrapper />
    </template>
    <TheHijackFooter v-if="isHijacked" />
  </template>

  <AppErrorPage v-else />
</template>

<script lang="ts">
import { mapGetters } from 'vuex'

import AppErrorPage from '@/app/views/AppErrorPage.vue'
import AppLoadingBar from '@/app/components/AppLoadingBar.vue'
import AppMaxVolumeAlert from '@/app/components/AppMaxVolumeAlert.vue'
import AppPaymentWallWrapper from '@/app/components/AppPaymentWallWrapper.vue'
import AppStatuspageWidget from '@/app/components/statuspage-widget/AppStatuspageWidget.vue'
import AppTitleBar from '@/app/components/AppTitleBar.vue'
import AppTopMenu from '@/app/components/AppTopMenu.vue'
import NotificationPanelWrapper from '@/app/components/notifications/NotificationPanelWrapper.vue'
import TheHijackFooter from '@/app/components/TheHijackFooter.vue'
import axios from '@/utils/axios'
import { unregisterClient } from '@/store/plugins/axios-request-count.js'

import { SHIPPING_LABEL_DETAILS_ROUTE } from '@/router/routes/shipping.routes'
import { RETURN_DETAILS_ROUTE } from '@/router/routes/returns.routes.js'
import { SETTINGS_ROUTE } from '@/router/routes/settings/settings.routes.names.js'
import { ONBOARDING_WIZARD_ROUTE } from '@/router/routes/onboarding-wizard.routes.js'

export default {
  components: {
    AppErrorPage,
    AppLoadingBar,
    AppMaxVolumeAlert,
    AppPaymentWallWrapper,
    AppStatuspageWidget,
    AppTitleBar,
    AppTopMenu,
    NotificationPanelWrapper,
    TheHijackFooter,
  },

  computed: {
    ...mapGetters(['user', 'settings', 'isHijacked', 'showOnboardingWizard']),

    wrapperClasses() {
      if (this.$route.name === SHIPPING_LABEL_DETAILS_ROUTE || this.$route.name === RETURN_DETAILS_ROUTE) {
        return 'main-wrapper main-wrapper--narrow'
      } else {
        return 'main-wrapper'
      }
    },

    isSettingsRoute() {
      return this.$route.matched.some(route => route.name === SETTINGS_ROUTE)
    },

    isOnboardingRoute() {
      return this.$route.matched.some(route => route.name === ONBOARDING_WIZARD_ROUTE)
    },
  },

  async created() {
    const preloader = document.querySelector('.preloader')
    if (preloader) {
      preloader.remove()
    }
  },

  beforeUnmount() {
    unregisterClient(axios)
  },
}
</script>
